<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="onClose"><span class="blind">X</span></button>
      <h2 class="layerTitle toCapitalize">{{locale.amenity_order}}</h2>
      <div class="category mb15">
        <button type="button" class="btn"
          v-for="item in category"
          :key="item"
          :class="{
            btnWhite: filter !== item}"
          @click="setFilter(item)">
          {{amenityCategory(item)}}
        </button>
      </div>
      <draggable class="setOrder"
        tag="div"
        v-model="orderList"
        v-bind="dragOptions">
        <transition-group type="transition"
          class="amenityList"
          tag="div">
          <div class="item"
            v-for="item in orderList"
            :key="item.raCode"
            :data-category="item.category"
            :class="{hide: hide(item)}">
              <div class="amenityInner">
                <img :src="require(`@/assets/img/amenity/${code(item.raCode)}.png`)" alt="" />
                <p class="name">{{name(item.raCode)}}</p>
              </div>
          </div>
        </transition-group>
      </draggable>
      <div class="sepApply">
        <button type="button" class="btn btnPrimary btnFull toUppercase" @click="onApply">{{locale.apply}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  props: [
    'locale'
  ],
  components: {
    draggable
  },
  computed: {
    localeAmenity () {
      return this.$store.state.service.localeAmenity.data
    },
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    category () {
      return this.$store.getters['amenity/getCategory']
    },
    listAll () {
      return this.$store.getters['amenity/getList']
    },
    service () {
      return this.$store.getters['amenity/getServiceList']
    },
    order () {
      return this.$store.getters['amenity/getOrder']
    }
  },
  mounted () {
    const listAll = this.listAll
    const serviceList = this.service.map(x => x)
    const serviceIds = this.service.map(x => x.raCode)
    const orderList = this.order.map(x => x)
    const orderIds = this.order.map(x => x.raCode)
    const hasOrder = orderList.filter(x => serviceIds.includes(x.raCode)).map(o => {
      const item = listAll.find(i => i.raCode === o.raCode)
      return item
    })
    const others = serviceList.filter(x => !orderIds.includes(x.raCode))
    this.orderList = [...new Set(hasOrder.concat(others))]
    this.setFilter(this.category[0])
  },
  data () {
    return {
      orderList: [],
      filter: ''
    }
  },
  methods: {
    code (raCode) {
      return raCode.toLowerCase()
    },
    name (raCode) {
      const code = this.code(raCode)
      const itemName = `amenity_${code}`
      return this.localeAmenity[itemName]
    },
    amenityCategory (categoryName) {
      const category = `amenity_category_${categoryName}`
      return this.locale[category]
    },
    setFilter (category) {
      this.filter = category
    },
    hide (item) {
      return item.category !== this.filter
    },
    onClose () {
      this.$emit('close')
    },
    onApply () {
      if (window.confirm(this.locale.confirm_amenity_order)) {
        const list = this.orderList
        this.$store.commit('amenity/setOrder', list)
        this.onClose()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer .inner {
  max-width: 800px;
  height: 100%;
}
.setOrder {
  height: 100%;
  overflow: auto;
  .item {
    cursor: move;
    background-color: $color-white;
  }
  .hide {
    display: none !important;
  }
}
.sepApply {
  width: 180px;
  margin: 30px auto 0;
}
.category {
  .btn + .btn {
    border-left: none;
  }
}
</style>
